const DEFAULT_CHARS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

type RandomStringParams = {
  chars?: string;
  length: number;
};

/** @notInstrumented */
export const randomString = ({
  chars = DEFAULT_CHARS,
  length,
}: RandomStringParams) => {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);

  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars[bytes[i] % chars.length];
  }
  return result;
};
